import React from "react";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "Packing by product risk",
    items: [
      "Books, cards, games and art prints need moisture and bend protection.",
      "Glazed ceramic and glass containers need separation and impact cushioning.",
      "Lotions, oils, scrubs and bath preparations need closed containers and leak containment.",
      "Jewellery needs small-part control and surface protection.",
      "Textiles and soft toys need clean, dry wrapping that avoids snagging or colour transfer.",
      "Modelling dough needs its product container kept closed and apart from food.",
    ],
  },
  {
    title: "Combined parcels",
    paragraphs: ["Different goods in one order may be separated inside the parcel where weight, liquid, sharp edge, crushing or hygiene risk requires it. Packaging can therefore vary with the product mix and destination while the order contents remain unchanged."],
  },
  {
    title: "Receiving and unpacking",
    paragraphs: ["Inspect the exterior before opening and keep labels and protective material until the contents have been checked. Open away from children when small parts, breakables or liquids are present. If a parcel is wet, crushed or leaking, photograph it before disturbing the arrangement where safe and follow the package-issue procedure."],
    links: [["Lost, Delayed & Damaged Packages", "/package-issues"]],
  },
  {
    title: "Reuse and local disposal",
    paragraphs: ["Clean material can be reused where it remains sound. Disposal and recycling depend on local acceptance, coatings, adhesive, food or cosmetic residue and mixed-material construction. Separate components only when safe and follow the destination's collection rules; a recycling symbol or paper appearance should not be treated as a universal acceptance guarantee."],
  },
  {
    title: "Sustainability statements",
    paragraphs: ["Environmental descriptions must be tied to a specific product or packaging fact that can be supported. The store does not treat reduced packaging, natural fibre or a recyclable component as proof that the whole order is waste-free, carbon-neutral or recyclable everywhere."],
  },
  {
    title: "Packaging concern",
    paragraphs: ["Report unnecessary damage, leakage, contamination or unsafe packing with the order reference and photographs. The product mix and packing method will be reviewed, and an immediate safety concern follows the damage and return process without limiting a compulsory remedy."],
  },
];

export default function Packaging() {
  return <PolicyPage title="Packaging & Sustainability Policy" intro="Risk-based packing for mixed physical goods and careful, fact-based disposal guidance." sections={sections} related={[["Shipping & Delivery", "/shipping"], ["Product Safety & Care", "/product-safety"]]} />;
}
